<template>
  <span ref="spanItem">
    <span v-if="sub.flowType != 'block'"
          class="li">
          <!-- @click="sub.flowType == 'flow' ? handleInsertFlowChild(sub,'mainNav') : openWin(sub)" -->
      <a :href="'javascript:;'"
         @mouseenter="suspension(sub)">
        <!-- <img v-if="sub.level != 1"
             :src="require('../assets/image/images/icons/sub_icon_menu.jpg')" /> -->
        {{sub.name}}
      </a>
    </span>
    <span class="process-arrow"
          v-if="!sub.level&&length!=index"></span>
    <!-- <menuBar :sub="sub"
             v-for="(sub,ind) in flowNavList"
             :key="ind"
             :index="ind"
             :length="flowNavList.length-1"></menuBar> -->
  </span>
</template>
<script>
import Bus from '../bus.js'
export default {
  name: "menuBar",
  components: {
    Bus
  },
  props: {
    sub: Object,
    index: Number,
    refeshMenus: Boolean,
    length: Number
  },
  data () {
    return {
      flowNavList: []
    }
  },
  watch: {
    'refeshMenus': function (val) {
      if (val) {
        this.flowNavList = [];
      }
    }
  },
  methods: {
    handleInsertFlowChild (sub, type) {
      Bus.$emit('refeshMenu', false);
      if (this.flowNavList.length) {
        this.flowNavList = [];
      } else {
        var appid = type == 'mainNav' ? sub.appId : (this.$appId)
        this.$http
          .get(
            "/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorNavList.json",
            {
              // ...this.$route.query
              appId: this.getQuery('appId'),
              flowId: sub.id
            }
          )
          .then(res => {
            if (res.state == 1) {
              this.flowNavList.push(...res.data.subNavArr);
              // this.$nextTick(() => {
              //   this.flowNavList.push(...res.data.blockArr);
              // });
            }
          });
      }
    },
    //触发外层mouseenter事件
    suspension (sub) {
      Bus.$emit('suspension', sub, this.index);
    },
    openWin (nav) {
      var wH = (window.innerHeight / 2) - 100;
      if (nav.flowType == "flow") {
        if (nav.url) {
          // this.open(nav.url,"_self");
          // window.location.reload();
          // window.location.assign(nav.url)
          // window.location.href = nav.url;
          // window.location.reload();
          var appid = nav.url.split('?appId=')[1];
          if (appid) {
            if (nav.url.indexOf(window.location.pathname) > -1) {
              // this.$router.replace({ name: 'Next', query: { appId: appid } });
              this.routerJump('replace','Next',{ appId: appid },nav.name);

            } else {
              // window.location.href = nav.url;
              this.open(nav.url,'_self',nav.name);
            }
          } else {
            // window.location.href = nav.url;
            this.open(nav.url,'_self',nav.name);
          }

        } else {
          this.$notify({
            position: 'top-right',
            title: '提示',
            message: '该流程暂无外展平台',
            type: 'warning',
            offset: wH
          });
        }
      }
      if (nav.flowType == "block") {
        if (nav.wzUrl) {
          // window.location.href = nav.wzUrl;
          this.open(nav.wzUrl,'_self',nav.name);
        } else if (nav.pageUrl) {
          // this.open(nav.pageUrl,"_self");
          // window.location.reload();
          // window.location.assign(nav.pageUrl)
          // window.location.href = nav.pageUrl;
          // window.location.reload();
          // let appid = nav.pageUrl.split('?appId=')[1];
          // if(appid){
          //   if(nav.pageUrl.indexOf(window.location.pathname)>-1){
          //     this.$router.replace({name:'Next',query:{appId:appid}});
          //   }else{
          //     window.location.href = nav.pageUrl;
          //   }
          // }else{
          //   window.location.href = nav.pageUrl;
          // }
          // window.location.href = nav.pageUrl;
          this.open(nav.pageUrl,'_self',nav.name);
        } else {
          this.$notify({
            position: 'top-right',
            title: '提示',
            message: '该流程暂无外展平台',
            type: 'warning',
            offset: wH
          });
        }
      }

    },
  }

}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menuBar.vue